import { FILEMANAGEMENT } from "../../constants/action-types";

const initialState = {
  is_FileUpload_Valid: [],
  fileManagement_data: [],
  fileManagement_tree_data: [],
  delete_file: [],
  add_directory: [],
  upload_file: [],
  rename_file: [],
  file_chunks_uploaded: [],
  file_management_configurations: [],
  file_management_folders: [],
  file_management_root_folders: [],
  file_management_folder_structure: [],
  validate_download: [],
};

const FileManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILEMANAGEMENT.IS_FILE_UPLOAD_VALID: {
      return Object.assign({}, state, {
        is_FileUpload_Valid: action.payload,
      });
    }
    case FILEMANAGEMENT.LOAD_FILE_MANAGEMENT_DATA: {
      return Object.assign({}, state, {
        fileManagement_data: action.payload,
      });
    }
    case FILEMANAGEMENT.LOAD_FILE_MANAGEMENT_TREE_DATA: {
      return Object.assign({}, state, {
        fileManagement_tree_data: action.payload,
      });
    }
    case FILEMANAGEMENT.DELETE_FILE: {
      return Object.assign({}, state, {
        delete_file: action.payload,
      });
    }
    case FILEMANAGEMENT.ADD_DIRECTORY: {
      return Object.assign({}, state, {
        add_directory: action.payload,
      });
    }
    case FILEMANAGEMENT.UPLOAD: {
      return Object.assign({}, state, {
        upload_file: action.payload,
      });
    }
    case FILEMANAGEMENT.RENAME: {
      return Object.assign({}, state, {
        rename_file: action.payload,
      });
    }
    case FILEMANAGEMENT.FILE_UPLOAD_BY_CHUNKS_COMPLETE: {
      return Object.assign({}, state, {
        file_chunks_uploaded: action.payload,
      });
    }
    case FILEMANAGEMENT.REMOVE_FILE_UPLOAD_CHUNKS_STATE: {
      return Object.assign({}, state, {
        file_chunks_uploaded: false,
      });
    }
    case FILEMANAGEMENT.FILE_MANAGEMENT_CONFIGURATIONS: {
      return Object.assign({}, state, {
        file_management_configurations: action.payload,
      });
    }
    case FILEMANAGEMENT.FILE_MANAGEMENT_GET_FOLDERS: {
      return Object.assign({}, state, {
        file_management_folders: action.payload,
      });
    }
    case FILEMANAGEMENT.FILE_MANAGEMENT_GET_FOLDER_STRUCTURE: {
      return Object.assign({}, state, {
        file_management_folder_structure: action.payload,
      });
    }
    case FILEMANAGEMENT.FILE_MANAGEMENT_GET_ROOT_FOLDERS: {
      return Object.assign({}, state, {
        file_management_root_folders: action.payload,
      });
    }
    case FILEMANAGEMENT.VALIDATE_DOWNLOAD: {
      return Object.assign({}, state, {
        validate_download: action.payload,
      });
    }

    default:
      return state;
  }
};

export default FileManagementReducer;
